import React from "react";

const OverviewHeader = ({ userName, dateLabel, onReportsClick, onTodayClick, onRefresh }) => {
  return (
    <div className="statistics-header">
      <div>
        <p className="statistics-header__greeting">Welcome, {userName}</p>
        <span className="statistics-header__date">{dateLabel}</span>
      </div>

      <div className="statistics-header__actions">
        {onRefresh && (
          <button
            type="button"
            className="statistics-header__button outline"
            onClick={onRefresh}
          >
            Refresh
          </button>
        )}
        <button
          type="button"
          className="statistics-header__button primary"
          onClick={onReportsClick}
        >
          Financial Reports
        </button>
        <button
          type="button"
          className="statistics-header__button outline"
          onClick={onTodayClick}
        >
          Today
        </button>
      </div>
    </div>
  );
};

export default OverviewHeader;

